import { Controller } from 'stimulus'

export default class DropdownController extends Controller {
  connect() {
    const dropdownButtons = document.querySelectorAll(".dropdown-button");
    const dropdownMenus = document.querySelectorAll(".dropdown-menu");
  
    dropdownButtons.forEach((button, index) => {
      button.addEventListener("click", function (event) {
        dropdownMenus[index].classList.toggle("hidden");
      });
    });
  
    window.addEventListener("click", function (event) {
      dropdownMenus.forEach((menu, index) => {
        if (
          !menu.contains(event.target) &&
          !dropdownButtons[index].contains(event.target)
        ) {
          menu.classList.add("hidden");
        }
      });
    });
  }

  disconnect() {
    window.removeEventListener("click", function (event) {
      dropdownMenus.forEach((menu, index) => {
        if (
          !menu.contains(event.target) &&
          !dropdownButtons[index].contains(event.target)
        ) {
          menu.classList.add("hidden");
        }
      });
    })
  }
}